module.exports = __webpack_public_path__ + "static/media/12.c1e8f3b0.svg";